import { createStorageHook } from "./storage";
var ref = createStorageHook("sessionStorage"), SessionStorage = ref.Storage, SessionStorageContext = ref.StorageContext, useSessionStorage = ref.useStorage, withSessionStorage = ref.withStorage;
export { SessionStorage, SessionStorageContext, useSessionStorage, withSessionStorage };
export default SessionStorage;
